// Notification utilities

export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('Este navegador no soporta notificaciones');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
};

export const sendNotification = (title, options = {}) => {
  // Verificar si el navegador soporta notificaciones
  if (!('Notification' in window)) {
    console.log('Este navegador no soporta notificaciones');
    return null;
  }
  
  if (Notification.permission === 'granted') {
    try {
      const notification = new Notification(title, {
        icon: '/favicon.ico',
        badge: '/favicon.ico',
        ...options
      });

      notification.onclick = () => {
        window.focus();
        notification.close();
      };

      return notification;
    } catch (error) {
      console.error('Error al enviar notificación:', error);
      return null;
    }
  }
  return null;
};

export const checkUpcomingAppointments = (appointments) => {
  const now = new Date();
  const upcomingAppointments = [];

  appointments.forEach(apt => {
    const aptDateTime = new Date(`${apt.date}T${apt.time}`);
    const timeDiff = aptDateTime - now;
    const minutesDiff = timeDiff / (1000 * 60);
    const hoursDiff = timeDiff / (1000 * 60 * 60);
    
    // Use custom reminder time if set, otherwise default to 120 minutes (2 hours)
    const reminderMinutes = apt.reminderTime || 120;

    // Notificar si la cita está dentro del tiempo de recordatorio y todavía no ha pasado
    if (minutesDiff > 0 && minutesDiff <= reminderMinutes && apt.status !== 'cancelled') {
      upcomingAppointments.push({
        ...apt,
        timeDiff,
        hoursDiff,
        minutesDiff
      });
    }
  });

  return upcomingAppointments;
};

export const getTodayAppointments = (appointments) => {
  const today = new Date().toISOString().split('T')[0];
  return appointments.filter(apt => apt.date === today && apt.status !== 'cancelled');
};

export const formatTimeRemaining = (hoursDiff) => {
  if (hoursDiff < 1) {
    const minutes = Math.floor(hoursDiff * 60);
    return `${minutes} minutos`;
  }
  const hours = Math.floor(hoursDiff);
  const minutes = Math.floor((hoursDiff - hours) * 60);
  return minutes > 0 ? `${hours}h ${minutes}min` : `${hours} hora${hours > 1 ? 's' : ''}`;
};